import { Box, Divider, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import AvatarIndicator from '../../../../../../../../../../Common/AvatorIndicator';
import { SessionSummaryFieldsFragment } from '../../../../../../../../../../generated/core-api/graphql-react-query';
import { useUserInfoData } from '../../../../../../../../../Hooks/useUserInfo';
import StyledBox from './styles';

interface SessionInfoProps {
  session: SessionSummaryFieldsFragment;
}
export default function SessionInfo(props: SessionInfoProps) {
  const { session } = props;
  const { t: tCommon } = useTranslation('common');
  const { t } = useTranslation('session');
  const dateFormat = new Intl.DateTimeFormat('en-US', { dateStyle: 'short' });
  const timeFormat = new Intl.DateTimeFormat('en-US', { timeStyle: 'short' });
  const userInfo = useUserInfoData();

  return (
    <>
      <StyledBox>
        <Box>
          <Typography variant="subtitle2">
            {tCommon('createdBy')}
          </Typography>
          <Box className="user">
            <AvatarIndicator user={session.userField} tooltip />
            <Typography>
              {session.userField.displayName}
            </Typography>
            {session.userField.displayName === userInfo.id && (
              <Typography>
                {`(${tCommon('you')})`}
              </Typography>
            )}
          </Box>
        </Box>
        <Box>
          <Typography variant="subtitle2">
            {tCommon('date')}
          </Typography>
          <Typography>
            {dateFormat.format(session.date)}
          </Typography>
        </Box>
        <Box>
          <Typography variant="subtitle2">
            {tCommon('time')}
          </Typography>
          <Typography>
            {timeFormat.format(session.date)}
          </Typography>
        </Box>
        <Box>
          <Typography variant="subtitle2">
            {t('details.display')}
          </Typography>
          <Typography>
            {t('list.displays', { count: session.displays?.length ?? 0 })}
          </Typography>
        </Box>
      </StyledBox>
      <Divider />
    </>
  );
}
